<template>
  <div class="question-box-radio-button">
    <p class="question-box-radio-button__question-label">
      {{ label }}
    </p>
    <div class="question-box-radio-button__question-group">
      <div
        v-for="(option, index) in localOptions"
        :key="
          `question-box-radio-button__question-${
            option.label
          }-${index}-${Math.random()}`
        "
        class="question-box-radio-button__answer"
        :class="{
          'question-box-radio-button__answer--checked': option.check,
          'question-box-radio-button__answer--invalid': error,
        }"
        @click="selectOption(option, index)"
      >
        <span class="question-box-radio-button__answer__wrapper-radio">
          <span class="question-box-radio-button__answer__radio">
            <input
              :checked="option.check"
              class="question-box-radio-button__answer__radio__input"
              :name="`question-box-radio-button__answer__${label}`"
              type="radio"
            />
          </span>
          <i
            class="question-box-radio-button__answer__radio-mark fas fa-circle"
          />
        </span>
        <label
          class="question-box-radio-button__answer__label"
          :for="`question-box-radio-button__answer__${label}`"
        >
          {{ option.label }}
        </label>
      </div>
    </div>
    <error
      v-if="localOptions && error"
      :message="customErrorMsg"
      variant="no-border"
    />
  </div>
</template>

<script>
import Error from 'custom-error';

export default {
  components: {
    Error,
  },
  props: {
    label: {
      type: String,
      default: () => '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => null,
    },
    error: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    customErrorMsg: {
      type: String,
      default() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
  },
  data: () => ({
    localOptions: [],
    selected: null,
    selectedIndex: null,
  }),
  watch: {
    options: {
      immediate: true,
      handler() {
        if (Array.isArray(this.options)) {
          this.localOptions = [...this.options];
        }
      },
    },
    value: {
      immediate: true,
      handler(current, old) {
        if (
          Array.isArray(this.localOptions) &&
          ((!old && current) || (current && old && current.value !== old.value))
        ) {
          let localOptions = [...this.localOptions];
          this.selected = { ...current };
          let selectedIndex = Number(this.selectedIndex);

          localOptions = localOptions.map((option, index) => {
            option.check = false;

            if (option.value === current.value) {
              option.check = true;
              selectedIndex = Number(index);
            }

            return option;
          });

          this.selectedIndex = selectedIndex;
          this.localOptions = [...localOptions];
        }
      },
    },
    error(newValue) {
      if (this.customErrorMsg == null) {
        this.errorMessage = newValue;
      }
    },
    customErrorMsg(newValue) {
      this.errorMessage = newValue;
    },
  },
  methods: {
    selectOption(selected, index) {
      this.selectedIndex = index;
      this.selected = { ...selected };
      this.$emit('input', selected);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.question-box-radio-button {
  color: map-get($colors, 'black') !important;
  font-weight: bold;

  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }

  &__question-label {
    border: solid map-get($colors, 'gray-5') 1px;
    padding-top: 1.2rem;
    padding-bottom: 0.625rem;
    padding-right: 1.8rem;
    padding-left: 1.8rem;
    border-top-left-radius: 0.4167rem;
    border-top-right-radius: 0.4167rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    margin-bottom: 0;
  }

  &__answer {
    border: solid map-get($colors, 'gray-5') 1px;
    background-color: map-get($colors, 'gray-9');
    display: flex;
    height: 66px;

    @media only screen and (max-width: 768px) {
      font-size: 12px;
    }

    &:last-child {
      border-bottom-left-radius: 0.4167rem;
      border-bottom-right-radius: 0.4167rem;
    }

    &--checked {
      background-color: map-get($colors, 'green');
      color: map-get($colors, 'white') !important;
    }

    &--invalid {
      background-color: map-get($colors, 'secondary-19');
      border-color: map-get($colors, 'red');
      color: map-get($colors, 'secondary-38') !important;
    }

    &__wrapper-radio {
      border-right-color: map-get($colors, 'gray-5');
      border-right-style: solid;
      border-right-width: 1px;
      height: 66px;
      width: 70px;
      position: relative;
    }

    &--invalid &__wrapper-radio {
      border-right-color: map-get($colors, 'red');
    }

    &__label {
      display: flex;
      justify-content: center;
      justify-content: start;
      align-items: center;
      margin: 0;
      margin-left: 1rem;

      @media only screen and (min-width: 768px) {
        padding-left: 0;
        justify-content: start;
      }
    }

    &__radio-mark,
    &__radio {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &__radio {
      height: 1.25rem;
      width: 1.25rem;
      background-color: map-get($colors, 'white');
      border: 1px solid map-get($colors, 'gray-5');
      border-radius: 50%;
      z-index: 12;

      &__input {
        display: none;
      }
    }

    &--checked &__radio-mark {
      color: map-get($colors, 'green');
      font-size: 0.8rem;
      z-index: 13;
    }
  }
}
</style>
